<h1 class="header">
  {{
    'inactive-sessions.component.are_you_still_there'
      | localise: 'Are you still there?'
  }}
</h1>
<div>
  <div class="content">
    {{
      'inactive-sessions.component.for_your_security'
        | localise
          : "For your security, we’ll log you out soon due to inactivity. Stay signed in by confirming you're still here."
    }}
  </div>
  <div class="timer-block">
    <div class="timer-content">
      <span class="timer-icon" aria-hidden="true">
        <svg viewBox="0 0 20 20">
          <path d="M10 5.15381V10.6923L13.6 12.4923"></path>
          <path
            d="M18.7592 12.0769C17.8216 16.0462 14.2558 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C13.4722 1 16.4853 2.96631 17.9862 5.84615"></path>
          <path d="M19.0006 3.07715V6.53869H15.5391"></path>
        </svg>
      </span>
      {{
        'inactive-sessions.component.your_online_session'
          | localise: 'Your online session will expire in'
      }}
    </div>
    <div class="timer">{{ remainedTime }}</div>
  </div>
</div>
<div class="action-modal-logout">
  <button mat-button [mat-dialog-close]="closeModalEvent">
    {{ 'inactive-sessions.component.log_out' | localise: 'Log out' }}
  </button>
  <button mat-button class="resume" mat-dialog-close>
    {{
      'inactive-sessions.component.resume_session' | localise: 'Resume session'
    }}
  </button>
</div>
